import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahsyogasci',
  templateUrl: './asahsyogasci.component.html',
  styleUrls: ['./asahsyogasci.component.scss']
})
export class AsahsyogasciComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
